import BaseModalV2 from 'components/TasksV2/UI/BaseModalV2'
import React, { useState } from 'react'
import useLocaleText from 'components/useLocaleText'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { useGroupService } from '../hooks/useGroupService'
import { GroupsForm } from '../Forms/GroupsForm'
import { ModalHeader } from '../../commonUI/Modal/ModalHeader'
import { ModalFooter } from '../../commonUI/Modal/ModalFooter'

interface IGroupModalProps {
  isOpen: boolean
  requestClose: () => void
  onClose: () => void
  uid: string
}

export const GroupModal: React.FC<IGroupModalProps> = ({ isOpen, onClose, uid, requestClose }) => {
  const t_update_groups = useLocaleText('edit_groups')
  const save_button = useLocaleText('admin_submit_button')
  const { mappedGroupIdsByUsers, groups, retailUsersObject } = useSelector((state: RootState) => state.config.config)
  const { updateUserGroups } = useGroupService()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedIds, setSelectedIds] = useState<string[]>(mappedGroupIdsByUsers[uid] || [])

  const onSelectionChange = (selectedIds: string[]) => {
    setSelectedIds(selectedIds)
  }

  const onSubmit = async () => {
    const initialGroups = mappedGroupIdsByUsers[uid] || []
    setIsLoading(true)

    try {
      await updateUserGroups(uid, selectedIds, initialGroups, groups, retailUsersObject)
      onClose()
    } catch (error) {
      console.error('Error updating groups:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={onClose}
      header={<ModalHeader title={t_update_groups} onClose={requestClose} />}
      body={<GroupsForm initialSelectedIds={selectedIds} onSelectionChange={onSelectionChange} />}
      footer={<ModalFooter isLoading={isLoading} onSubmit={onSubmit} buttonText={save_button} />}
      modalContentProps={{
        w: '100%',
        maxW: '600px',
        minW: '400px',
      }}
      modalBodyProps={{
        backgroundColor: 'white !important',
        height: { base: 'auto', md: '600px', lg: 'max-content' },
      }}
      modalHeaderProps={{ boxShadow: 'none' }}
    />
  )
}
